import { valueof } from "api/common/utils/type.utils";

//TODO: Update these to be more specific
export const ALERT_TYPES = {
  ASSURANCE_MAINTENANCE: "Assurance Maintenance",
  VALIDATION: "Validation",
  RELEASE: "Release",
} as const;
export type AlertType = valueof<typeof ALERT_TYPES>;

//TODO: Update these to be more specific
export const ALERT_SOURCES = {
  ASSURANCE_MAINTENANCE: "Assurance Maintenance",
  VALIDATION: "Validation",
  RELEASE: "Release",
} as const;
export type AlertSource = valueof<typeof ALERT_SOURCES>;

//TODO: Update these to be more specific
export const ALERT_RECIPIENTS = {
  VALIDATOR_RESOURCE_TEAM: "Validator Resource Team",
  NIAP_MANAGEMENT: "NIAP Management",
  VENDOR: "Vendor",
  LAB: "Lab",
} as const;
export type AlertRecipient = valueof<typeof ALERT_RECIPIENTS>;

export interface AlertAndMailData {
  subject: string;
  recipients: {
    to: AlertRecipient[];
    cc: AlertRecipient[];
  };
  alert_type: AlertType;
  alert_text: string;
  alert_type_id: string | number;
  alert_source: AlertSource;
  note?: string;
}
